/* eslint-disable import/no-extraneous-dependencies */
import { createPortal } from 'react-dom';
import toast from 'react-hot-toast';
import IC_CLOSE from '../assets/ic_close.svg';
import IC_DIAM from '../assets/ic_diam.png';

// import { useNavigate } from 'react-router-dom';
// import {
//   BitKeepAdapter, OkxWalletAdapter, TokenPocketAdapter, TronLinkAdapter,
// } from '@tronweb3/tronwallet-adapters';
// import { WalletConnectAdapter } from '@tronweb3/tronwallet-adapter-walletconnect';
// import { LedgerAdapter } from '@tronweb3/tronwallet-adapter-ledger';
// import IC_TRON_LINk from '../assets/ic_tron_link.svg';
// import IC_WALLET_CONNECT from '../assets/ic_wallet_connect.svg';
// import IC_TOKEN_POCKET from '../assets/ic_token_pocket.svg';
// import IC_BITGET from '../assets/ic_bitget.svg';
// import IC_OKX from '../assets/ic_okx.svg';
// import IC_LEDGER from '../assets/ic_ledger.png';

const container = document.createElement('div');
container.id = 'ui-portal';
document.body.appendChild(container);

function Portal({ children }) {
  return createPortal(children, container);
}

function WalletConnectDialog({
  isOpen,
  onCancel,
}) {
  // const navigate = useNavigate();
  async function handleDiam() {
    try {
      // if (window.diam) {
      //   console.log('Diam extension is installed!');
      const result = await window.diam.connect();
      console.log('Result', JSON.stringify(result));
      if (result.status === 200) {
        console.log('Diam address', result.message.data);
        toast('Wallet connected successfully');
        // navigate('connect-wallet');
        // onCancel();
      }
      // }
    } catch (error) {
      toast(`Error ${error}`);
      console.error(error);
    }
  }
  // async function handleTronLink() {
  //   try {
  //     const tronLinkAdapter = new TronLinkAdapter();
  //     await tronLinkAdapter.connect();
  //     const response = await tronLinkAdapter.signMessage('Welcome to Green Vision');
  //     console.log('tronlink response', response);
  //     navigate('connect-wallet');
  //     onCancel();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }
  // async function handleWalletConnect() {
  //   try {
  //     const walletConnectAdapter = new WalletConnectAdapter({
  //       network: 'Nile',
  //       options: {
  //         relayUrl: 'wss://relay.walletconnect.com',
  //         projectId: '5fc507d8fc7ae913fff0b8071c7df231',
  //         metadata: {
  //           name: 'Test DApp',
  //           description: 'JustLend WalletConnect',
  //           url: 'https://your-dapp-url.org/',
  //           icons: ['https://your-dapp-url.org/mainLogo.svg'],
  //         },
  //       },
  //       web3ModalConfig: {
  //         themeMode: 'dark',
  //         themeVariables: {
  //           '--w3m-z-index': '1000',
  //         },
  //       },
  //     });
  //     await walletConnectAdapter.connect();
  //     const response = await walletConnectAdapter.signMessage("Welcome to Green Vision");
  //     console.log("wallet connect response", response);
  //     navigate('connect-wallet');
  //     onCancel();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async function handleTokenPocket() {
  //   try {
  //     console.log("Tokenpocket call");
  //     const tokenPocketAdapter = new TokenPocketAdapter();
  //     await tokenPocketAdapter.connect();
  //     const response = await tokenPocketAdapter.signMessage("Welcome to Green Vision");
  //     console.log("tokenpocket response", response);
  //     toast(`tokenpocket response ${response}`);
  //     navigator.clipboard.writeText(`tokenpocket response ${response}`)
  //     navigate('connect-wallet');
  //     onCancel();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async function handleBitGet() {
  //   try {
  //     console.log('Log3');
  //     const bitKeepAdapter = new BitKeepAdapter();
  //     await bitKeepAdapter.connect();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async function handleOKX() {
  //   try {
  //     console.log('Log4');
  //     const okxwalletAdapter = new OkxWalletAdapter();
  //     await okxwalletAdapter.connect();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  // async function handleLedger() {
  //   try {
  //     console.log('Log6');
  //     const ledger = new LedgerAdapter({ accountNumber: 2 });
  //     await ledger.connect();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <div className="ui-overlay" />
      <div className="ui-dialog">
        <h5 className="text-white mx-auto my-3">Connect Wallet1</h5>
        <div className="ui-dialog__body">
          <div className="ui-dialog__body__row" onClick={handleDiam} style={{ padding: '12px 15px' }}>
            <img alt="ic_tron_link" src={IC_DIAM} style={{ height: 22 }} />
            <div className="text-white fs-6">Diamente</div>
          </div>
          {/* <div className="ui-dialog__body__row" onClick={handleTronLink}>
            <img alt="ic_tron_link" src={IC_TRON_LINk} style={{ width: 35 }} />
            <div className="text-white fs-6">TronLink</div>
          </div> */}
          {/* <div className="ui-dialog__body__row" onClick={handleWalletConnect}>
            <img alt="ic_wallet_connect" src={IC_WALLET_CONNECT} style={{ width: 35 }} />
            <div className="text-white fs-6">WalletConnect</div>
          </div>
          <div className="ui-dialog__body__row" onClick={handleTokenPocket}>
            <img alt="ic_token_pocket" src={IC_TOKEN_POCKET} style={{ width: 35 }} />
            <div className="text-white fs-6">TokenPocket</div>
          </div> */}
          {/* <div className="ui-dialog__body__row" onClick={handleBitGet}>
            <img alt="ic_bitget" src={IC_BITGET} style={{ width: 35 }} />
            <div className="text-white fs-6">BitGet Wallet</div>
          </div>
          <div className="ui-dialog__body__row" onClick={handleOKX}>
            <img alt="ic_okx" src={IC_OKX} style={{ width: 35 }} />
            <div className="text-white fs-6">OKX</div>
          </div>
          <div className="ui-dialog__body__row" onClick={handleLedger}>
            <img alt="ic_ledger" src={IC_LEDGER} style={{ width: 35 }} />
            <div className="text-white fs-6">Ledger</div>
          </div> */}
        </div>
        <span style={{ fontSize: '0.9rem' }} className="text-white mx-auto text-center pt-3 pb-2"> Choosing to connect indicates that you have accepted</span>
        <div className="flex mx-auto" style={{ color: 'var(--text-color)', fontSize: '0.9rem' }}>
          <span>《Terms of Service》</span>
          <span>《Privacy Policy》</span>
        </div>
        {onCancel && (
          <img className="ui-dialog__close" onClick={onCancel} alt=" " src={IC_CLOSE} />
        )}
      </div>
    </Portal>
  );
}

export default WalletConnectDialog;
